import React from 'react'
import { Help } from '@next-nx/shared-ui/icons'
import styles from './InfoBox.module.sass'


interface Props {
  text: string
  className?: string
}

const InfoBox = (props: Props) => {

  const { 
    text = '',
    className = '',
  } = props

  return text ? (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.icon}>
        <Help />
      </div>
      <div className={styles.description} dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  ) : <></>
}

export default InfoBox
